import { customerAccountSetup } from '../../lib/oem-client';
import { roleLabel } from './display-copy';
import { useEffect, useState } from 'react';
import { authClient, passwordCallbackVerification } from '../../lib/auth';
import {
  cancelPasswordSetup,
  finishPasswordSetup,
  passwordSigninPath,
  passwordSetupOperation,
} from '../../lib/auth-setup';
export function PasswordSetup() {
  const [verified, setVerified] = useState<boolean | null>(null);
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const operation = passwordSetupOperation(sessionStorage);
  const [scope, setScope] = useState<Awaited<ReturnType<typeof customerAccountSetup>> | null>(null);
  const [consent, setConsent] = useState(false);
  useEffect(() => {
    void passwordCallbackVerification.then(async (valid) => {
      if (valid && operation) {
        try {
          setScope(await customerAccountSetup(operation));
        } catch {
          valid = false;
        }
      }
      setVerified(valid);
    });
  }, [operation]);
  async function finish() {
    if (!authClient || !verified || !navigator.onLine || (operation && (!consent || !scope)))
      return;
    setBusy(true);
    try {
      await finishPasswordSetup(
        authClient.auth,
        sessionStorage,
        password,
        confirmation,
        operation
          ? (chosenPassword) => customerAccountSetup(operation, true, chosenPassword)
          : undefined,
      );
      setPassword('');
      setConfirmation('');
      window.location.replace(passwordSigninPath);
    } catch {
      setError(
        'ยังยืนยันการตั้งรหัสผ่านและรับคำเชิญไม่ได้ ลองอีกครั้งด้วยรหัสผ่านเดิม หากลิงก์หมดอายุหรือสิทธิ์ถูกยกเลิก กรุณาติดต่อผู้เชิญ',
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <main className="frame login-frame">
      <section className="card">
        <div className="brand">
          <span className="wordmark">SQI</span>
          <span className="brandtitle">PRODUCT STUDIO</span>
        </div>
        <h1>ตั้งรหัสผ่าน</h1>
        <p>ตั้งรหัสผ่านสำหรับบัญชีที่ได้รับเชิญ หรือรหัสผ่านใหม่ของคุณ แล้วเข้าสู่ระบบอีกครั้ง</p>
        {verified === null ? (
          <p role="status">กำลังตรวจสอบลิงก์…</p>
        ) : verified ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              void finish();
            }}
          >
            <label>
              รหัสผ่านใหม่
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={12}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <label>
              ยืนยันรหัสผ่าน
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={12}
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
              />
            </label>
            <p>อย่างน้อย 12 ตัวอักษร</p>
            {scope ? (
              <label>
                <input
                  type="checkbox"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  required
                />
                รับคำเชิญเข้าถึง {scope.label} · {roleLabel(scope.role)} · เข้าถึงได้ถึง{' '}
                {new Date(scope.expiresAt).toLocaleString('th-TH')}
              </label>
            ) : null}
            <button
              className="action"
              disabled={busy || Boolean(operation && (!scope || !consent))}
            >
              {operation ? 'ตั้งรหัสผ่านและรับคำเชิญ' : 'บันทึกรหัสผ่านและออกจากระบบ'}
            </button>
          </form>
        ) : (
          <p role="alert" className="note-danger">
            ลิงก์ใช้ไม่ได้หรือหมดอายุ กรุณาขอลิงก์ใหม่จากผู้ดูแล หรือใช้ลืมรหัสผ่าน
          </p>
        )}
        {error ? (
          <p role="alert" className="note-danger">
            {error}
          </p>
        ) : null}
        <button
          type="button"
          disabled={busy}
          onClick={() => {
            if (!authClient) {
              window.location.replace(passwordSigninPath);
              return;
            }
            setBusy(true);
            void cancelPasswordSetup(authClient.auth, sessionStorage).then(
              () => window.location.replace(passwordSigninPath),
              () => {
                setError('ออกจากระบบไม่ได้ กรุณาลองใหม่');
                setBusy(false);
              },
            );
          }}
        >
          ยกเลิกและกลับหน้าเข้าสู่ระบบ
        </button>
      </section>
    </main>
  );
}
